import "./index.css";
// src/NewProjectSection/NewProjectSection.tsx
import Box4 from "@cloudscape-design/components/box";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween5 from "@cloudscape-design/components/space-between";
import * as React2 from "react";
import { useAppTranslation as useAppTranslation4 } from "@amzn/awsmp-max-translations";

// src/PromptInput/PromptInput.tsx
import PromptInputComponent from "@cloudscape-design/components/prompt-input";
import Box3 from "@cloudscape-design/components/box";
import SpaceBetween4 from "@cloudscape-design/components/space-between";
import Link2 from "@cloudscape-design/components/link";
import FormField from "@cloudscape-design/components/form-field";
import FileInput from "@cloudscape-design/components/file-input";
import FileDropzone, { useFilesDragging } from "@cloudscape-design/components/file-dropzone";
import Icon from "@cloudscape-design/components/icon";
import FileTokenGroup from "@cloudscape-design/components/file-token-group";
import Spinner2 from "@cloudscape-design/components/spinner";
import * as React from "react";
import { ContentBlockVisibility, ACCEPTED_EXTENSIONS_STRING, validateFiles } from "@amzn/awsmp-max-model";
import { useAppTranslation as useAppTranslation3, AppTrans as AppTrans3 } from "@amzn/awsmp-max-translations";

// src/DisclaimerModal/AwsTermsDisclaimerModal.tsx
import Modal from "@cloudscape-design/components/modal";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import TextContent from "@cloudscape-design/components/text-content";
import Link from "@cloudscape-design/components/link";
import { useAppTranslation, AppTrans } from "@amzn/awsmp-max-translations";
import { jsx, jsxs } from "react/jsx-runtime";
var AwsTermsDisclaimerModal = ({ visible, onDismiss }) => {
  const { t } = useAppTranslation();
  return /* @__PURE__ */ jsx(
    Modal,
    {
      size: "medium",
      onDismiss,
      visible,
      header: t("disclaimer"),
      footer: /* @__PURE__ */ jsx(Box, { float: "right", children: /* @__PURE__ */ jsx(Button, { variant: "primary", onClick: onDismiss, children: t("close") }) }),
      "data-testid": "aws-terms-disclaimer-modal",
      children: /* @__PURE__ */ jsx(SpaceBetween, { direction: "vertical", size: "m", children: /* @__PURE__ */ jsx(TextContent, { children: /* @__PURE__ */ jsxs(AppTrans, { i18nKey: "disclaimerModalContent", children: [
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/terms/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/aup/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/ai/responsible-ai/policy/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/privacy/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/terms/" })
      ] }) }) })
    }
  );
};

// src/DisclaimerModal/AiContentDisclaimerModal.tsx
import Modal2 from "@cloudscape-design/components/modal";
import Box2 from "@cloudscape-design/components/box";
import Button2 from "@cloudscape-design/components/button";
import SpaceBetween2 from "@cloudscape-design/components/space-between";
import TextContent2 from "@cloudscape-design/components/text-content";
import { useAppTranslation as useAppTranslation2, AppTrans as AppTrans2 } from "@amzn/awsmp-max-translations";
import { jsx as jsx2 } from "react/jsx-runtime";

// src/PromptInput/PromptInput.module.scss
var PromptInput_module_default = {
  FooterContainer: "PromptInput_module_FooterContainer",
  FooterLinksContainer: "PromptInput_module_FooterLinksContainer",
  SecondaryActionsContainer: "PromptInput_module_SecondaryActionsContainer",
  SecondaryActionsPadding: "PromptInput_module_SecondaryActionsPadding",
  LightGreyText: "PromptInput_module_LightGreyText",
  StatusContainer: "PromptInput_module_StatusContainer",
  StatusText: "PromptInput_module_StatusText",
  StatusTextError: "PromptInput_module_StatusTextError"
};

// src/PromptInput/StatusMessage.tsx
import Alert from "@cloudscape-design/components/alert";
import SpaceBetween3 from "@cloudscape-design/components/space-between";
import Spinner from "@cloudscape-design/components/spinner";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var StatusMessage = ({ type, message, onDismiss }) => {
  if (type === "error") {
    return /* @__PURE__ */ jsx3(Alert, { type: "error", dismissible: !!onDismiss, onDismiss, children: message });
  }
  return /* @__PURE__ */ jsx3(Alert, { type: "info", dismissible: false, children: /* @__PURE__ */ jsxs2(SpaceBetween3, { direction: "horizontal", size: "xs", alignItems: "center", children: [
    /* @__PURE__ */ jsx3(Spinner, {}),
    /* @__PURE__ */ jsx3("span", { children: message })
  ] }) });
};

// src/PromptInput/PromptInput.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var CloudscapePromptInput = PromptInputComponent;
var PromptInput = React.forwardRef(
  ({ lines = 1, placeholderText, onSubmit, isDisabled, loading, promptInputAction, logger }, ref) => {
    const { t } = useAppTranslation3();
    const maxLength = 4e3;
    const { areFilesDragging } = useFilesDragging();
    const [value, setValue] = React.useState("");
    const [disclaimerVisible, setDisclaimerVisible] = React.useState(false);
    const [files, setFiles] = React.useState([]);
    const [uploadProgress, setUploadProgress] = React.useState({});
    const [uploadErrors, setUploadErrors] = React.useState({});
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [templateVisibility, setTemplateVisibility] = React.useState(void 0);
    const internalRef = React.useRef(null);
    const inputRef = ref || internalRef;
    const prevDisabledRef = React.useRef(isDisabled);
    const disableSend = !value.trim() && files.length === 0 || value.length > maxLength;
    const handleFileChange = React.useCallback(
      (newFiles) => {
        const validFiles = [];
        const errors = {};
        newFiles.forEach((file) => {
          const validation = validateFiles([file]);
          if (!validation.isValid) {
            errors[file.name] = validation.errors.join(". ");
          } else {
            validFiles.push(file);
          }
        });
        if (validFiles.length > 0) {
          setFiles((prev) => [...prev, ...validFiles]);
        }
        if (Object.keys(errors).length > 0) {
          const invalidFiles = newFiles.filter((f) => errors[f.name]);
          setFiles((prev) => [...prev, ...invalidFiles]);
          setUploadErrors((prev) => ({ ...prev, ...errors }));
        }
      },
      [setFiles, setUploadErrors]
    );
    React.useEffect(() => {
      if (prevDisabledRef.current === true && isDisabled === false) {
        inputRef.current?.focus();
      }
      prevDisabledRef.current = isDisabled;
    }, [isDisabled, inputRef]);
    React.useEffect(() => {
      const action = promptInputAction?.action;
      const consume = promptInputAction?.consume;
      if (action && inputRef.current) {
        if (action.type === "insert-text") {
          setValue(action.text);
          if (action.visibility) {
            setTemplateVisibility(action.visibility);
          }
          setTimeout(() => {
            if (inputRef.current && action.selectionStart !== void 0 && action.selectionEnd !== void 0) {
              inputRef.current.setSelectionRange(action.selectionStart, action.selectionEnd);
            }
            inputRef.current?.focus();
          }, 0);
        }
        consume?.();
      }
    }, [promptInputAction, inputRef]);
    const handleSubmit = React.useCallback(() => {
      try {
        setError(null);
        console.log("Logger", logger);
        logger?.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "send-message-button"
          }
        });
        if (disableSend) {
          return;
        }
        const hadFilesToUpload = files.length > 0;
        const uploadedFileNames = files.map((f) => f.name);
        let messageContent = value.trim();
        if (!messageContent && hadFilesToUpload) {
          messageContent = t("analyzeUploadedFiles", {
            plural: uploadedFileNames.length > 1 ? "s" : "",
            files: uploadedFileNames.join(", ")
          });
        }
        const contentBlocks = [];
        if (messageContent) {
          const isAutoGenerated = !value.trim() && hadFilesToUpload;
          contentBlocks.push({
            text: value.trim() || messageContent,
            visibility: templateVisibility ?? (isAutoGenerated ? ContentBlockVisibility.INFERENCE_ONLY : void 0)
          });
        }
        const uploadCallbacks = {
          onProgress: (fileName, percent) => {
            setUploadProgress((prev) => ({ ...prev, [fileName]: percent }));
          },
          onSuccess: (fileName) => {
            setUploadProgress((prev) => ({ ...prev, [fileName]: 100 }));
            setFiles((prev) => prev.filter((f) => f.name !== fileName));
          },
          onError: (fileName, errorMsg) => {
            setUploadErrors((prev) => ({ ...prev, [fileName]: errorMsg }));
          },
          onProcessing: () => {
            setIsProcessing(true);
          },
          onComplete: () => {
            setIsProcessing(false);
          }
        };
        onSubmit({
          contentBlocks,
          files,
          uploadCallbacks
        });
        setValue("");
        setTemplateVisibility(void 0);
      } catch (err) {
        setError(err instanceof Error ? err.message : t("failedToSendMessage"));
      }
    }, [onSubmit, files, value, disableSend, templateVisibility, logger, t]);
    const getStatusMessage = () => {
      const uploadingFiles = Object.keys(uploadProgress).filter((fileName) => uploadProgress[fileName] < 100);
      const errorFiles = Object.keys(uploadErrors);
      if (errorFiles.length > 0) {
        return {
          type: "error",
          message: t("failedToUploadFiles", {
            count: errorFiles.length,
            plural: errorFiles.length > 1 ? "s" : ""
          })
        };
      }
      if (isProcessing) {
        return {
          type: "updating",
          message: t("scanningFiles")
        };
      }
      if (uploadingFiles.length > 0) {
        return {
          type: "updating",
          message: t("uploadingFiles")
        };
      }
      return null;
    };
    const statusMessage = getStatusMessage();
    const spinnerPriority = React.useMemo(() => {
      if (statusMessage && statusMessage.type === "updating") {
        return "file-upload";
      }
      if (loading) {
        return "send-message";
      }
      return null;
    }, [statusMessage, loading]);
    const isUploading = Object.values(uploadProgress).some((progress) => progress < 100);
    return /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "s", children: [
      error && /* @__PURE__ */ jsx4(StatusMessage, { type: "error", message: error, onDismiss: () => setError(null) }),
      /* @__PURE__ */ jsx4(
        FormField,
        {
          stretch: true,
          className: PromptInput_module_default.FormFieldPadding,
          "data-testid": "standard-layout-form-field",
          constraintText: /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.FooterContainer, "data-testid": "standard-layout-footer", children: [
            /* @__PURE__ */ jsx4("span", { "data-testid": "standard-layout-disclaimer", children: /* @__PURE__ */ jsxs3(AppTrans3, { i18nKey: "promptAgreeToDisclaimer", children: [
              /* @__PURE__ */ jsx4(Link2, { variant: "primary", onFollow: () => setDisclaimerVisible(true), "data-testid": "standard-layout-disclaimer-link" }),
              /* @__PURE__ */ jsx4("br", {})
            ] }) }),
            " ",
            /* @__PURE__ */ jsx4("span", { "data-testid": "standard-layout-character-count", children: t("characterCount", { current: value.length, max: maxLength }) })
          ] }),
          errorText: value.length > maxLength && t("promptTooManyCharacters"),
          children: /* @__PURE__ */ jsx4(
            CloudscapePromptInput,
            {
              ref: inputRef,
              "data-testid": "standard-layout-prompt-input",
              onChange: ({ detail }) => setValue(detail.value),
              disabled: isDisabled || isUploading || isProcessing || loading,
              disableActionButton: disableSend || loading,
              onAction: handleSubmit,
              value,
              actionButtonAriaLabel: loading ? t("sending") : t("sendMessage"),
              actionButtonIconName: loading ? void 0 : "send",
              actionButtonIconSvg: spinnerPriority === "send-message" ? /* @__PURE__ */ jsx4(Spinner2, { size: "normal", "data-testid": "action-button-spinner" }) : void 0,
              placeholder: placeholderText,
              minRows: lines,
              disableSecondaryActionsPaddings: true,
              secondaryActions: /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.SecondaryActionsContainer, "data-testid": "standard-layout-secondary-actions", children: [
                /* @__PURE__ */ jsx4(
                  FileInput,
                  {
                    variant: "icon",
                    ariaLabel: t("uploadFiles"),
                    multiple: true,
                    value: files,
                    accept: ACCEPTED_EXTENSIONS_STRING,
                    onChange: ({ detail }) => {
                      detail.value.forEach((file) => {
                        logger?.biMetric({
                          metricName: "Click",
                          value: 1,
                          unit: "Count",
                          dimensions: {
                            ClickSelect: "file-upload-button",
                            ClickAct: `${file.size}`
                          }
                        });
                      });
                      handleFileChange(detail.value);
                    },
                    "data-testid": "standard-layout-file-input"
                  }
                ),
                statusMessage && /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.StatusContainer, children: [
                  spinnerPriority === "file-upload" && /* @__PURE__ */ jsx4(Spinner2, { size: "normal" }),
                  /* @__PURE__ */ jsx4("span", { className: statusMessage.type === "error" ? PromptInput_module_default.StatusTextError : PromptInput_module_default.StatusText, children: statusMessage.message })
                ] })
              ] }),
              secondaryContent: areFilesDragging ? /* @__PURE__ */ jsx4(FileDropzone, { onChange: ({ detail }) => handleFileChange(detail.value), "data-testid": "standard-layout-file-dropzone", children: /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "xs", alignItems: "center", children: [
                /* @__PURE__ */ jsx4(Icon, { name: "upload", "data-testid": "standard-layout-upload-icon" }),
                /* @__PURE__ */ jsx4(Box3, { "data-testid": "standard-layout-drop-text", children: t("dropFilesHere") })
              ] }) }) : files.length > 0 && /* @__PURE__ */ jsx4(
                FileTokenGroup,
                {
                  "data-testid": "standard-layout-file-tokens",
                  items: files.map((file) => {
                    const progress = uploadProgress[file.name];
                    const error2 = uploadErrors[file.name];
                    return {
                      file,
                      loading: progress !== void 0 && progress < 100,
                      errorText: error2
                    };
                  }),
                  onDismiss: ({ detail }) => {
                    const removedFile = files[detail.fileIndex];
                    setFiles((files2) => files2.filter((_, index) => index !== detail.fileIndex));
                    setUploadErrors((prev) => {
                      const newErrors = { ...prev };
                      delete newErrors[removedFile.name];
                      return newErrors;
                    });
                  },
                  alignment: "horizontal",
                  showFileSize: true,
                  showFileLastModified: true,
                  showFileThumbnail: true,
                  i18nStrings: {
                    removeFileAriaLabel: () => t("removeFile"),
                    limitShowFewer: t("showFewerFiles"),
                    limitShowMore: t("showMoreFiles"),
                    errorIconAriaLabel: t("errorIconAriaLabel"),
                    warningIconAriaLabel: t("warningIconAriaLabel")
                  }
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ jsx4(AwsTermsDisclaimerModal, { visible: disclaimerVisible, onDismiss: () => setDisclaimerVisible(false) })
    ] });
  }
);
PromptInput.displayName = "PromptInput";

// src/NewProjectSection/NewProjectSection.module.scss
var NewProjectSection_module_default = {
  taskCardsContainer: "NewProjectSection_module_taskCardsContainer",
  taskCard: "NewProjectSection_module_taskCard",
  taskCardContent: "NewProjectSection_module_taskCardContent",
  taskIcon: "NewProjectSection_module_taskIcon",
  taskTextContent: "NewProjectSection_module_taskTextContent",
  taskTitle: "NewProjectSection_module_taskTitle",
  taskDescription: "NewProjectSection_module_taskDescription"
};

// src/NewProjectSection/compare-products-icon.svg
var compare_products_icon_default = 'data:image/svg+xml,<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="28" height="28" rx="4" fill="url(%23paint0_radial_3506_157158)"/>%0A<path d="M17.643 10.3571C17.4352 9.23764 16.9255 8.19624 16.169 7.34533C15.4125 6.49442 14.4379 5.86633 13.3505 5.52887C12.263 5.19141 11.1041 5.15741 9.99878 5.43054C8.89345 5.70366 7.88372 6.27354 7.07863 7.07863C6.27354 7.88372 5.70366 8.89345 5.43054 9.99878C5.15741 11.1041 5.19141 12.263 5.52887 13.3505C5.86633 14.4379 6.49442 15.4125 7.34533 16.169C8.19624 16.9255 9.23764 17.4352 10.3571 17.643C10.5649 18.7625 11.0746 19.8039 11.8311 20.6548C12.5876 21.5057 13.5622 22.1338 14.6496 22.4712C15.7371 22.8087 16.896 22.8427 18.0013 22.5696C19.1067 22.2964 20.1164 21.7266 20.9215 20.9215C21.7266 20.1164 22.2964 19.1067 22.5696 18.0013C22.8427 16.896 22.8087 15.7371 22.4712 14.6496C22.1338 13.5622 21.5057 12.5876 20.6548 11.8311C19.8039 11.0746 18.7625 10.5649 17.643 10.3571ZM11.8665 14.6251L13.3751 16.1336C12.7797 16.3761 12.1429 16.5006 11.5001 16.5001C11.4995 15.8572 11.624 15.2204 11.8665 14.6251ZM14.5032 15.4946L12.5055 13.4969C12.7883 13.122 13.122 12.7883 13.4969 12.5055L15.4946 14.5032C15.2118 14.8781 14.8781 15.2118 14.5032 15.4946ZM16.1336 13.3751L14.6251 11.8665C15.2204 11.624 15.8572 11.4995 16.5001 11.5001C16.5006 12.1429 16.3761 12.7797 16.1336 13.3751ZM6.50005 11.5001C6.49765 10.2814 6.94043 9.10376 7.74517 8.18855C8.54991 7.27335 9.6612 6.68356 10.8702 6.53004C12.0792 6.37652 13.3026 6.66983 14.3105 7.35486C15.3185 8.03988 16.0415 9.06944 16.3438 10.2501C14.7413 10.2922 13.2161 10.9478 12.0829 12.0817C10.9497 13.2156 10.295 14.7413 10.254 16.3438C9.18027 16.066 8.22915 15.4396 7.54978 14.563C6.8704 13.6864 6.50119 12.6091 6.50005 11.5001ZM16.5001 21.5C15.3915 21.4991 14.3146 21.1305 13.4381 20.4519C12.5615 19.7733 11.9349 18.823 11.6563 17.7501C13.2595 17.7089 14.7857 17.0537 15.9197 15.9197C17.0537 14.7857 17.7089 13.2595 17.7501 11.6563C18.9307 11.9586 19.9602 12.6816 20.6452 13.6896C21.3303 14.6975 21.6236 15.9209 21.4701 17.1299C21.3165 18.3389 20.7268 19.4502 19.8115 20.2549C18.8963 21.0597 17.7187 21.5024 16.5001 21.5Z" fill="white"/>%0A<defs>%0A<radialGradient id="paint0_radial_3506_157158" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(30.4992 -2.49915) rotate(135) scale(46.6667 59.7097)">%0A<stop stop-color="%23B8E7FF"/>%0A<stop offset="0.3" stop-color="%230099FF"/>%0A<stop offset="0.45" stop-color="%235C7FFF"/>%0A<stop offset="0.6" stop-color="%238575FF"/>%0A<stop offset="0.8" stop-color="%23962EFF"/>%0A</radialGradient>%0A</defs>%0A</svg>%0A';

// src/NewProjectSection/create-proposal-icon.svg
var create_proposal_icon_default = 'data:image/svg+xml,<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="28" height="28" rx="4" fill="url(%23paint0_radial_3506_157171)"/>%0A<path d="M20.6922 10.4328L16.3172 6.05781C16.2591 5.99979 16.1902 5.95378 16.1143 5.92241C16.0384 5.89105 15.9571 5.87494 15.875 5.875H8.375C8.04348 5.875 7.72554 6.0067 7.49112 6.24112C7.2567 6.47554 7.125 6.79348 7.125 7.125V20.875C7.125 21.2065 7.2567 21.5245 7.49112 21.7589C7.72554 21.9933 8.04348 22.125 8.375 22.125H19.625C19.9565 22.125 20.2745 21.9933 20.5089 21.7589C20.7433 21.5245 20.875 21.2065 20.875 20.875V10.875C20.8751 10.7929 20.859 10.7116 20.8276 10.6357C20.7962 10.5598 20.7502 10.4909 20.6922 10.4328ZM16.5 8.00859L18.7414 10.25H16.5V8.00859ZM19.625 20.875H8.375V7.125H15.25V10.875C15.25 11.0408 15.3158 11.1997 15.4331 11.3169C15.5503 11.4342 15.7092 11.5 15.875 11.5H19.625V20.875ZM16.5 15.875C16.5 16.0408 16.4342 16.1997 16.3169 16.3169C16.1997 16.4342 16.0408 16.5 15.875 16.5H14.625V17.75C14.625 17.9158 14.5592 18.0747 14.4419 18.1919C14.3247 18.3092 14.1658 18.375 14 18.375C13.8342 18.375 13.6753 18.3092 13.5581 18.1919C13.4408 18.0747 13.375 17.9158 13.375 17.75V16.5H12.125C11.9592 16.5 11.8003 16.4342 11.6831 16.3169C11.5658 16.1997 11.5 16.0408 11.5 15.875C11.5 15.7092 11.5658 15.5503 11.6831 15.4331C11.8003 15.3158 11.9592 15.25 12.125 15.25H13.375V14C13.375 13.8342 13.4408 13.6753 13.5581 13.5581C13.6753 13.4408 13.8342 13.375 14 13.375C14.1658 13.375 14.3247 13.4408 14.4419 13.5581C14.5592 13.6753 14.625 13.8342 14.625 14V15.25H15.875C16.0408 15.25 16.1997 15.3158 16.3169 15.4331C16.4342 15.5503 16.5 15.7092 16.5 15.875Z" fill="white"/>%0A<defs>%0A<radialGradient id="paint0_radial_3506_157171" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(30.4992 -2.49915) rotate(135) scale(46.6667 59.7097)">%0A<stop stop-color="%23B8E7FF"/>%0A<stop offset="0.3" stop-color="%230099FF"/>%0A<stop offset="0.45" stop-color="%235C7FFF"/>%0A<stop offset="0.6" stop-color="%238575FF"/>%0A<stop offset="0.8" stop-color="%23962EFF"/>%0A</radialGradient>%0A</defs>%0A</svg>%0A';

// src/NewProjectSection/NewProjectSection.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var NewProjectSection = ({
  projectCreation,
  navigation,
  logger,
  variant = "full",
  promptLines = 5,
  placeholderText
}) => {
  const { createProjectWithStreaming, error } = projectCreation;
  const { navigate } = navigation;
  const { t } = useAppTranslation4();
  const [loading, setLoading] = React2.useState(false);
  React2.useEffect(() => {
    if (error) {
      setLoading(false);
    }
  }, [error]);
  const deepResearchLabel = /* @__PURE__ */ jsx5(Box4, { variant: "awsui-gen-ai-label", children: t("deepResearch") });
  const taskCards = [
    {
      title: t("compareProducts"),
      description: t("compareProductsDescription"),
      iconUrl: compare_products_icon_default,
      labelComponent: deepResearchLabel,
      onClick: () => {
        logger.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "compare-products-button"
          }
        });
        navigate("compare");
      }
    },
    {
      title: t("createProposal"),
      description: t("createProposalDescription"),
      iconUrl: create_proposal_icon_default,
      labelComponent: deepResearchLabel,
      onClick: () => {
        logger.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "create-proposal-button"
          }
        });
        navigate("proposal");
      }
    }
  ];
  const handleSubmit = React2.useCallback(
    ({ contentBlocks, files, uploadCallbacks }) => {
      const firstBlock = contentBlocks[0];
      const firstBlockText = firstBlock && "text" in firstBlock ? firstBlock.text : "";
      setLoading(true);
      const sanitizedText = firstBlockText.replace(/[\x00-\x1F\x7F]/g, " ").replace(/[\uD800-\uDFFF]/g, "").trim();
      const projectNameText = sanitizedText.slice(0, 50);
      createProjectWithStreaming({
        projectName: `Project: ${projectNameText}${sanitizedText.length > 50 ? "..." : ""}`,
        agent: { agentId: "none" },
        contentBlocks,
        files,
        uploadCallbacks
      });
    },
    [createProjectWithStreaming]
  );
  const showContainer = variant === "full";
  const showHeader = variant === "full";
  const content = /* @__PURE__ */ jsxs4(SpaceBetween5, { direction: "vertical", size: "s", children: [
    showHeader && /* @__PURE__ */ jsx5(Header, { variant: "h2", children: t("newProject") }),
    /* @__PURE__ */ jsx5(Box4, { padding: { top: "s" }, children: /* @__PURE__ */ jsx5(
      PromptInput,
      {
        lines: promptLines,
        placeholderText: placeholderText || t("tellUsAboutYourBusinessNeed"),
        onSubmit: handleSubmit,
        loading,
        logger
      }
    ) }),
    /* @__PURE__ */ jsx5(Box4, { padding: { top: "s" }, children: /* @__PURE__ */ jsxs4(SpaceBetween5, { direction: "vertical", size: "xs", children: [
      /* @__PURE__ */ jsx5(Header, { variant: "h3", children: t("tryTheseTasks") }),
      /* @__PURE__ */ jsx5("div", { className: NewProjectSection_module_default.taskCardsContainer, children: taskCards.map((card, index) => /* @__PURE__ */ jsx5("div", { className: NewProjectSection_module_default.taskCard, onClick: card.onClick, children: /* @__PURE__ */ jsxs4("div", { className: NewProjectSection_module_default.taskCardContent, children: [
        /* @__PURE__ */ jsx5("img", { src: card.iconUrl, alt: card.title, width: "28", height: "28", className: NewProjectSection_module_default.taskIcon }),
        /* @__PURE__ */ jsxs4("div", { className: NewProjectSection_module_default.taskTextContent, children: [
          /* @__PURE__ */ jsx5("div", { className: NewProjectSection_module_default.taskTitle, children: card.title }),
          /* @__PURE__ */ jsx5("div", { className: NewProjectSection_module_default.taskDescription, children: card.description })
        ] }),
        card.labelComponent
      ] }) }, index)) })
    ] }) })
  ] });
  return showContainer ? /* @__PURE__ */ jsx5(Container, { children: content }) : content;
};
export {
  NewProjectSection
};
//# sourceMappingURL=index.js.map
